export default __webpack_public_path__ + "static/academic-4cfa985a1ce279ce7a463365dd92d0a3.svg";